import { render, staticRenderFns } from "./policiesAndRegulations.vue?vue&type=template&id=0b3c180a&scoped=true&"
import script from "./policiesAndRegulations.vue?vue&type=script&lang=js&"
export * from "./policiesAndRegulations.vue?vue&type=script&lang=js&"
import style0 from "./policiesAndRegulations.vue?vue&type=style&index=0&id=0b3c180a&prod&lang=less&scoped=true&"
import style1 from "./policiesAndRegulations.vue?vue&type=style&index=1&id=0b3c180a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3c180a",
  null
  
)

export default component.exports